/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useDispatch } from 'react-redux';
import { AppDispatchType } from 'modules/store';

export const useAppDispatch = () => useDispatch<AppDispatchType>();
